module.exports = __webpack_public_path__ + "static/media/morefilters.bfd89fb3.svg";